import React from "react";
import classNames from "classnames";

import "./IconButton.scss";

interface IconButtonProps {
  children: React.ReactNode;
  color?: "default" | "green";
  disabled?: boolean;
  className?: string;
  onClick?(): void;
}

const IconButton = ({ children, color = "default", disabled, className, onClick }: IconButtonProps) => {
  const classes = classNames(`icon-button icon-button-${color}`, className);

  return (
    <button onClick={onClick} disabled={disabled} className={classes}>
      {children}
    </button>
  );
};

export default IconButton;
